import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HandleError } from '../../../../components/common/utils/handleError.component';
import { PolizaEntity } from '../../entities/polizas_cliente_entity';
import { RedesEmpresaServices } from './redeEmpresa.service';
import { RedesVamEntity } from '../../../vam/vam_entity';
import { RedesEmpresa } from './redes_entity';
const swal = require("sweetalert2");

@Component({
    selector: 'redesEmpresa',
    templateUrl: 'redesEmpresa.template.html'
})

export class RedesEmpresaComponent implements OnChanges {
    @Input() polizaContratada: PolizaEntity;
    redesPlanes: RedesVamEntity[];
    redes: RedesEmpresa[];
    nombresPlanes: string[];
    showLoader: string;

    constructor(private route: ActivatedRoute, private router: Router, private handleError: HandleError, public redesService: RedesEmpresaServices) { }

    ngOnChanges() {
        this.redes = new Array<RedesEmpresa>();
        this.showLoader = "sk-loading";
        this.nombresPlanes = new Array<string>();
        this.redesService.consultaRedesVAMEmpresa(this.polizaContratada).subscribe(
            result => {
                let numero = 1;
                result.forEach(a => {
                    a.CodigoUnico = numero;
                    numero++;
                });
                this.redesPlanes = new Array<RedesVamEntity>();
                this.redesPlanes = result;

                let curr: string[] = this.redesPlanes.map(data => data.NombrePlan);
                this.nombresPlanes = curr.filter((x, i, a) => x && a.indexOf(x) === i);
                this.nombresPlanes.sort();
                this.nombresPlanes.forEach(a => {
                    let red = new RedesEmpresa();
                    red.nombrePlan = a;
                    red.redesVamEntity = this.redesPlanes.filter(b => b.NombrePlan == a);
                    this.redes.push(red);
                });
                this.showLoader = "";
            },
            error => {
                this.handleError.redirectUrl(error);
                this.showLoader = "";
            }
        );
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/redes/redesEmpresa.component.ts